import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Checkbox from "./checkbox";
// check
export default function TimeToDo({
  group,
  isFocused,
  isLeft,
  isRight,
  formatTime,
  selectedTaskId,
  setSelectedTaskId,
  calculateRemainingTime,
  checkedTasks,
  setCheckedTasks,
  taskStarted,
  setTaskStarted,
}) {
  const [selectedTaskState, setSelectedTaskState] = useState(selectedTaskId);
  const [startedTaskId, setStartedTaskId] = useState(null);
  const [count, setCount] = useState(() => {
    const selectedTask = group.tasks.find(
      (task) => task.taskId === selectedTaskState
    );
    return selectedTask ? selectedTask.timeRequired * 60 : 0; // Default to 0 if no task is found
  });

  useEffect(() => {
    if (count <= 0) {
      setTaskStarted(false);
    }
    if (count <= 0) return;

    const timer = setInterval(() => {
      setCount((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [count]);

  // useEffect(() => {
  //   if (!taskStarted || !selectedTaskState) return;

  //   const task = group.tasks.find((task) => task.taskId === selectedTaskState);
  //   if (!task) return;

  //   const timer = setTimeout(() => {
  //     setTaskStarted(false);
  //   }, task.timeRequired * 60 * 60 * 1000); // Converted minutes to milliseconds

  //   return () => clearTimeout(timer); // Cleanup previous timeout when dependencies change
  // }, [taskStarted, selectedTaskState]);

  function time_Convertor(time) {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = Math.floor(time % 60);

    return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")} left`;
  }
  // Calculate time remaining for a task
  const startTimer = (task) => {
    const remainingSeconds = calculateRemainingTime(task, group);
    // group.tasks.find((task) => task.taskId === selectedTaskState) ||
    //     group.tasks[0]
    if (remainingSeconds <= 0) return "0:00:00 left";

    return time_Convertor(remainingSeconds);
  };
  const finishTimer = (task) => {
    const remainingSeconds = calculateRemainingTime(task, group);
    // group.tasks.find((task) => task.taskId === selectedTaskState) ||
    //     group.tasks[0]
    const taskTimer = count;
    if (remainingSeconds <= 0) return "0:00:00 left";

    return time_Convertor(taskTimer);
  };

  // Find the selected task or default to the first task
  const findSelectedTask = () =>
    group.tasks.find((task) => task.taskId === selectedTaskState) ||
    group.tasks[0];

  const selectedTask = findSelectedTask();
  // const timeRemaining = taskStarted
  //   ? "Started"
  //   : getTimeRemaining(selectedTask);
  const timeRemaining =
    taskStarted &&
    calculateRemainingTime(selectedTask, group) > 0 &&
    startedTaskId === selectedTaskState
      ? finishTimer(selectedTask)
      : startTimer(selectedTask);

  return (
    <div
      className={`to-do list ${isFocused ? "focused" : ""} ${
        isLeft ? "left" : ""
      } ${isRight ? "right" : ""}`}
    >
      <div className="task-time">
        <span className="dot"></span>
        <span>{formatTime(group.timeToDo)}</span>
      </div>

      <div
        className={`taskbar ${isFocused ? "focused" : ""} ${
          isLeft ? "left" : ""
        } ${isRight ? "right" : ""}`}
      >
        <div className="Task-Headers">
          <Icon icon="cuida:edit-outline" className="icon-time" />
          <div className="Time-Left">
            <div className="time-remaining">
              <span className="icon-timer">
                <Icon icon="mdi:timer-play-outline" id="timer" />
              </span>
              <p id="time">{timeRemaining}</p>
            </div>
            <p>
              {taskStarted && startedTaskId === selectedTaskState
                ? "to finish"
                : "to start"}
            </p>
          </div>
          <Icon icon="mage:filter" className="icon-time" />
        </div>

        <div className="Tasks">
          {group.tasks.map((task, index) => {
            const isSelected = task.taskId === selectedTaskState;
            const remainingSeconds = calculateRemainingTime(task, group);
            const isFirst = index === 0;

            return (
              <ul
                key={task.taskId}
                style={isSelected ? { opacity: "1" } : undefined}
                className={`${isFirst ? "CurrentTask" : "tasknotfocus"} ${
                  isSelected && !isFirst ? "taskfocus" : ""
                }`}
                onClick={() =>
                  setSelectedTaskState(
                    task.taskId === selectedTaskState ? null : task.taskId
                  )
                }
              >
                <Checkbox
                  isTimeOver={remainingSeconds <= 0}
                  taskname={task.name}
                  priority={task.priority}
                  checkedTasks={checkedTasks}
                  setCheckedTasks={setCheckedTasks}
                  taskId={task.taskId}
                  isSelected={isSelected}
                  isFirst={isFirst}
                  taskStarted={taskStarted}
                  setTaskStarted={setTaskStarted}
                  setCount={setCount}
                  group={group}
                  selectedTaskState={selectedTaskState}
                  startedTaskId={startedTaskId}
                  setStartedTaskId={setStartedTaskId}
                />
              </ul>
            );
          })}
        </div>
      </div>
    </div>
  );
}
